import { render, staticRenderFns } from "./OrderRejectByProvider.vue?vue&type=template&id=f99b2036"
import script from "./OrderRejectByProvider.vue?vue&type=script&lang=js"
export * from "./OrderRejectByProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports